import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import { DataGrid } from "@mui/x-data-grid";
import { esES } from "@mui/x-data-grid/locales";
import EstadoVacio from "./EstadoVacio";
import { fpDataGridSx } from "./dataGridStyles";

/**
 * DataGrid estándar de la casa: estilos fp, textos en español, skeleton al
 * cargar (pásele `loading`) y estado vacío ilustrado. En vez de:
 *
 *   <DataGrid rows={rows} columns={columns} sx={fpDataGridSx} />
 *
 * use:
 *
 *   <FpDataGrid rows={rows} columns={columns} loading={cargando}
 *     vacioSubtitulo='Seleccione los filtros y haga clic en "Procesar".' />
 */

function TablaCargando() {
  return (
    <Box sx={{ p: 2, display: "flex", flexDirection: "column", gap: 1 }}>
      {[0, 1, 2, 3, 4, 5].map((i) => (
        <Skeleton key={i} variant="rounded" height={34} sx={{ opacity: 1 - i * 0.13 }} />
      ))}
    </Box>
  );
}

export default function FpDataGrid({ vacioIcono, vacioTitulo, vacioSubtitulo, sx, slots, ...props }) {
  return (
    <DataGrid
      localeText={esES.components.MuiDataGrid.defaultProps.localeText}
      disableRowSelectionOnClick
      rowHeight={44}
      sx={{ ...fpDataGridSx, ...(sx || {}) }}
      slots={{
        noRowsOverlay: () => (
          <EstadoVacio compacto icono={vacioIcono} titulo={vacioTitulo} subtitulo={vacioSubtitulo} />
        ),
        loadingOverlay: TablaCargando,
        ...(slots || {}),
      }}
      {...props}
    />
  );
}
